import { checkPermission } from '../utils/permission';

export const useCanEditInfo = (): boolean => checkPermission(2, 3);

